import { setToastState } from "components/Toast/Toast.slice";
import { IOffers } from "features/offers/offers.interface";
import { activeFilters } from "features/search-property/searchproperty.slice";
import { clearSearchResult } from "features/search-result/searchresult.slice";

export const formattedTitle = (
  title: string,
  highlight: string,
  titleStyle: string,
  highlightStyle: string,
  addDot: boolean,
) => {
  if (
    highlight &&
    highlight.length > 0 &&
    title.toLowerCase().includes(highlight.toLowerCase())
  ) {
    let startIndex = title.toLowerCase().indexOf(highlight.toLowerCase());
    let endIndex =
      title.toLowerCase().indexOf(highlight.toLowerCase()) +
      highlight.toLowerCase().length;

    return (
      <p className="ellipsis">
        <span className={`${titleStyle}`}>
          {title.substring(0, startIndex)}
        </span>
        <span className={`${highlightStyle}`}>
          {title.substring(startIndex, endIndex)}
        </span>
        <span className={`${titleStyle}`}>
          {title.substring(endIndex, title.length)}
          {addDot && !title.includes(".") ? "." : null}
        </span>
      </p>
    );
  }
  return title ? (
    <p className="ellipsis">
      <span className={`${titleStyle}`}>
        {title}
        {addDot && !title.includes(".") ? "." : null}
      </span>
    </p>
  ) : null;
};

export const handleShareOffer = (
  data: IOffers,
  t: (key: string) => string,
  dispatch: any,
  e?: React.MouseEvent | undefined,
) => {
  e?.stopPropagation();
  const shareUrl = `${window.location.origin}/offers/${data.slug || ""}`;

  if (navigator.share) {
    navigator
      .share({
        title: data.title,
        text: data.description_1,
        url: shareUrl,
      })
      .catch((error) => {
        console.log("Error sharing", error);
        dispatch(
          setToastState({
            type: "danger",
            message: t("toast.linkCopiedFail") || "Failed to copy link.",
            dismiss: 3500,
          }),
        );
      });
  } else {
    navigator.clipboard.writeText(shareUrl).then(() => {
      dispatch(
        setToastState({
          type: "success",
          message: t("toast.linkCopied") || "Link copied to clipboard!",
          dismiss: 3500,
        }),
      );
    });
  }
};

export const routeToOfferDetails = (
  data: IOffers,
  history: any,
  dispatch: any,
) => {
  const params: any = {};
  params["offer_id"] = data.id;
  params["page"] = null;
  dispatch(clearSearchResult());
  dispatch(activeFilters(params));
  if (data.slug) {
    history.push(`/offers/${data.slug}`);
  } else {
    dispatch(setToastState({ type: 'danger', message: 'toast.offerError', dismiss: 3500 }));
    history.push("/search-results");
  }
}
